import SplitLink from '@/store/module/automation/SplitLink';

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {},
    modules: {
        SplitLink,
    },
};
